module.exports = __webpack_public_path__ + "img/box6-15.1ec80cef.png";